<template>
  <div>
    <v-layout column class="mt-4 ml-4">
      <header-elements icon='mdi-code-not-equal-variant' @showUpload="showUpload=!showUpload" title='Programmes'></header-elements>
      <elements-table :items="programmes" :showUpload="showUpload" @showUpload="showUpload=!showUpload" title="Programme"></elements-table>

        <!-- <div class="mt-4 mb-3">
          <v-flex style="background-color:#e2e2e2;" class="px-3 py-2 elevation-1 xs12">
            <h3 class="subtitle xs12 flex">Programmes</h3>
            </v-flex>
        </div>       -->
        <!-- <v-flex xs12 sm12 md12> -->
          <!-- <v-list class="xs12">
            <v-list-tile v-for="f in programmes" :key="f.id">
              <v-list-tile-title>
                <b>{{f.title}}</b>
              </v-list-tile-title>
              <v-list-tile-title>Programme Container: {{f.programme_container}}</v-list-tile-title>
              <v-list-tile-title>bitrate: {{f.bitrate}}</v-list-tile-title>
              <v-list-tile-action>
                <v-btn @click="done_programme" icon ><v-icon small>edit</v-icon></v-btn>
              </v-list-tile-action>
              <v-list-tile-action v-if="c_user.delete_rights">
                <v-btn @click="delete_programme" icon ><v-icon small>delete</v-icon></v-btn>
              </v-list-tile-action>
            </v-list-tile>
            <v-divider></v-divider>
          </v-list> -->
          <!-- <v-flex class="mt-0 mb-0 xs12" v-show="!showUpload">
            <v-btn icon @click="showUpload=!showUpload"><v-icon>add</v-icon></v-btn> Add new programme
          </v-flex> -->
          <v-flex class="mt-0 mb-0 xs12" v-show="showUpload">
            <v-btn icon @click="showUpload=!showUpload"><v-icon>close</v-icon></v-btn> Cancel
          </v-flex>
          <v-flex v-show="showUpload">
            <v-container grid-list-xs fluid  class="elevation-3">
              <v-layout row wrap>
                <h4 class="headline">Add new programme</h4>
                <edit-field v-for="field in fields" v-show="show_field_c(field)" :id="field.name" :name="field.name"
                  :class="'flex ' + (field.class ? field.class : 'xs12')" :artwork="artwork" 
                  :field="field" 
                  :key="field.key"
                  :programme="programme"
                  v-model="field.name" 
                >
                </edit-field>
              </v-layout>
            </v-container>
            <v-btn @click="add">save</v-btn>
            <v-btn @click="showUpload=!showUpload">cancel</v-btn>
          </v-flex>
        <!-- </v-flex> -->
      <!-- </v-card> -->
    </v-layout>
  </div>
</template>

<script>
  const show_field = (field) => {
    if (field.condition && programme) {
      var theInstructions = field.condition;
      var F = (theInstructions) => {}
      return(F());
    } else {
      return true
    }
  }
  import EditField from './EditField'
  import HeaderElements from './HeaderElements'
  import ElementsTable from './ElementsTable'

  export default {
    props: ['artwork'],
    data: () => ({
      programmes: [],
      programme: {
        title: '',
        content: '',
        behaviour: '',
        appearance: '',
        context: '',
        concept: '',
        structure: '',
        input_output: '',
        filesize: '',
        associated_devices: '',
        other_associated_devices: '',
        associated_information_carriers: '',
        creation_date: '',
        notes: ''
      },
      showUpload: false,
      show: false,
      fields: [
        {
          'ctype': 'text-short',
          'name': 'programme.title',
          'title': 'Title',
          column: true,
          class: 'xs12',
          edit: true,
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
          user_groups: ['admin', 'manager']
        },
        {
          'ctype': 'text-short',
          'name': 'programme.content',
          'title': 'Content',
          class: 'xs6',
          work_types: ['fvs'],
          user_groups: ['admin', 'manager']
        },
        {
          'ctype': 'text-short',
          'name': 'programme.behaviour',
          'title': 'Behaviour (duration | sound | interaction',
          class: 'xs6',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
          user_groups: ['admin', 'manager']
        },
        {
          'ctype': 'text-short',
          'name': 'programme.appearance',
          'title': 'Appearance (color | color space | resolution)',
          class: 'xs6',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
          user_groups: ['admin', 'manager']
        },
        {
          'ctype': 'text-short',
          'name': 'programme.context',
          'title': 'Context (application software environment operating system hardware environment proprietary – custom-built commercial)',
          class: 'xs6',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
          user_groups: ['admin', 'manager']
        },
        {
          'ctype': 'text-short',
          'name': 'programme.concept',
          'title': 'Concept',
          class: 'xs6',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
          user_groups: ['admin', 'manager']
        },
        {
          'ctype': 'radio',
          'etype': 'radio',
          'selection': [
            {id: '1', value: '1', name: 'Single File'},
            {id: '2', value: '2', name: 'Multiple Files'},
            {id: '3', value: '3', name: 'Programme'},
            {id: '4', value: '4', name: 'Network'},
            {id: '5', value: '5', name: 'Pure Code'},
            {id: '6', value: '6', name: 'Other'}
          ],
          'name': 'programme.structure',
          'title': 'Structure',
          class: 'xs12',
          work_types: ['fvs'],
          user_groups: ['admin', 'manager']
        },
        {
          'ctype': 'text-short',
          'name': 'programme.input_output',
          'title': 'Input/Output devices',
          class: 'xs6',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
          user_groups: ['admin', 'manager']
        },
        {
          'ctype': 'text-short',
          'name': 'programme.filesize',
          'title': 'File Size',
          suffix: 'MB',
          class: 'xs6',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
          user_groups: ['admin', 'manager']
        },
        {
          'ctype': 'text-long',
          'name': 'programme.associated_devices',
          'title': 'Associated Devices to read data',
          class: 'xs12',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
          user_groups: ['admin', 'manager']
        },
        {
          'ctype': 'text-long',
          'name': 'programme.other_associated_devices',
          'title': 'Other Associated Devices',
          class: 'xs12',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
          user_groups: ['admin', 'manager']
        },
        {
          'ctype': 'text-long',
          'name': 'programme.associated_information',
          'title': 'Associated Information carriers (format migration story)',
          column: true,
          class: 'xs12',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
          user_groups: ['admin', 'manager']
        },
        {
          'ctype': 'date',
          'name': 'programme.creation_date',
          'title': 'Creation Date)',
          column: true,
          class: 'xs6',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
          user_groups: ['admin', 'manager']
        },
        {
          'ctype': 'text-long',
          'name': 'programme.notes',
          'title': 'Notes)',
          column: true,
          class: 'xs12',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
          user_groups: ['admin', 'manager']
        },
      ]
    }),
    methods: {
      set_input(f) {
        programme[f]= f
      },
      download () {},
      add () {
        this.programmes.push(this.programme)
        this.showUpload=!this.showUpload
      },
      delete_programme () {},
      done_programme () {},
      show_field_c (field) {
        // console.log(this.programme)
        return show_field(field,this.programme)
      }
    },
    computed: {
    },
    components: {
      EditField, HeaderElements,ElementsTable
      }
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/artworks/Programme.vue